var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/category-did-you-mean.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "category/templates/category-did-you-mean.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("searchUrl")) {
var t_4 = t_1.searchUrl;
} else {
cb(new Error("cannot import 'searchUrl'")); return;
}
context.setVariable("searchUrl", t_4);
output += "<h2 class=\"c-search-did-you-mean__heading\">\n\t";
output += runtime.suppressValue((lineno = 5, colno = 3, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_did-you-mean"])), env.opts.autoescape);
output += " &nbsp;\n    ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"products")),"didYouMean");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("suggestion", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") <= 5) {
output += "\n            <a class=\"c-search-did-you-mean__a\" href=\"";
output += runtime.suppressValue((lineno = 8, colno = 64, runtime.callWrap(t_4, "searchUrl", context, ["q=" + "" + t_8])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_8, env.opts.autoescape);
output += "</a>";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
output += "&nbsp;";
;
}
;
}
output += "\n    ";
;
}
}
frame = frame.pop();
output += "\n</h2>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/category-did-you-mean.j2"] , dependencies)